import { render, staticRenderFns } from "./_2.vue?vue&type=template&id=8cf27aba&scoped=true&"
import script from "./_2.vue?vue&type=script&lang=js&"
export * from "./_2.vue?vue&type=script&lang=js&"
import style0 from "./_2.vue?vue&type=style&index=0&id=8cf27aba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf27aba",
  null
  
)

export default component.exports